module.exports = __webpack_public_path__ + "img/hombre.0ae21ab2.png";